<template>
  <div style="height: 100%;width: 100%;display: flex;flex-direction: row">

    <div v-if="fileType=='others'"  style="width:100%;height: 100%">
      <el-empty description="抱歉，该文件类型暂不支持预览"></el-empty>
    </div>

    <div v-else-if="need_transfer==true"  style="width:100%;height: 100px;line-height: 100px">
      <div style="text-align: center;width: 100%;line-height: 60px;height: 60px">该文件需要转换格式才能预览</div>
      <div style="text-align: center;width: 100%;line-height: 60px;height: 60px">
          <el-button type="primary" @click="startTransfer" :loading="loading">开始格式转换</el-button>
          <el-button type="primary" @click="getPreviewInfo" >刷新</el-button>
          <span>{{transfer_status}}</span>
      </div>

    </div>

    <div v-else-if="fileType=='pdf'" style="width:100%;height: 100%;overflow: hidden">
      <iframe :src="'/static/pdfjs-3.2.146-dist/web/viewer.html?file=' + url" style="width:100%;height: 100%"/>
    </div>

    <div v-else-if="fileType=='img'" style="width: 100%;height: 99%;overflow:hidden">
      <img id="img" :style="{transform:'scale(1)'}" :src=url @mousedown.prevent="dropImage" @mouseup.prevent="loosen" @mousewheel.prevent='gunlun'/>
    </div>

    <div v-else-if="fileType=='mp4'"  style="width:100%;height: 100%">
      <video
          id="myVideo"
          :src="url"
          :controls="true"
          controlslist="nodownload"
          autoplay
          @contextmenu.prevent
          style="width: 100%;height: 100%;object-fit:contain;" >
      </video>
    </div>

  </div>
</template>

<script>


export default {
  name: "FileViewer",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    fileType: {
      type: String
    },
    url: {
      type: String
    }
  },
  data() {
    return {
      file_id:'',
      need_transfer: false,
      transfer_status:'',
      transfer_file_urls:[],
      tranfer_file_url_0:'',
      loading:false,
      positionX: 0,
      positionY: 0,
      odiv: null,
      timer: null,
      multiples: 1
    }
  },
  methods: {
    gunlun(e) {
      let direction = e.deltaY > 0 ? 'down' : 'up'
      if (direction === 'up') {
        if (this.multiples >= 10) {
          return;
        }
        this.multiples += 0.25;
        // 滑轮向上滚动
      } else {
        if (this.multiples <= 0.5) {
          return;
        }
        this.multiples -= 0.25;
        // 滑轮向下滚动
      }
    },
    dropImage(e) {
      if (e === null) {
        return
      }
      this.odiv = e.target;        //获取目标元素
      //算出鼠标相对元素的位置
      let disX = e.clientX - this.odiv.offsetLeft;
      let disY = e.clientY - this.odiv.offsetTop;
      document.onmousemove = (e) => {       //鼠标按下并移动的事件
                                            //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let left = e.clientX - disX;
        let top = e.clientY - disY;

        //绑定元素位置到positionX和positionY上面
        this.positionX = top;
        this.positionY = left;

        //移动当前元素
        this.odiv.style.left = left + 'px';
        this.odiv.style.top = top + 'px';
      }
    },
    loosen() {
      document.onmousemove = null;
      document.onmouseup = null;
    },
  },
}
</script>

<style scoped>

img {
  height: 100%;
  width: auto;
  position: relative;
}

</style>
